export const availableLots = ({ values, lots }) => {
  if (!values || !lots) return null;
  const lotsFiltered = values.populations.filter((pop) => parseInt(pop.quantity, 10) === pop.size_remain).map((item) => item.lot);
  const result = lots.filter((lot) => !lotsFiltered.includes(lot.id));
  return result;
};
